import React from "react";
import { Scale, FileText, Shield, Users, Scroll, Gavel, Handshake, Landmark } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DirittoCivileEContrattualistica() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const services = [{
    title: "Strategic Planning",
    description: "Forging resilient pathways for organizational growth through data-driven insights and market foresight.",
    icon: Shield
  }, {
    title: "Operational Design",
    description: "Refining structural workflows to enhance productivity and foster a culture of sustainable efficiency.",
    icon: Scale
  }, {
    title: "Asset Optimization",
    description: "Maximizing the value of physical and intellectual resources through precision-guided management strategies.",
    icon: Landmark
  }, {
    title: "Digital Integration",
    description: "Seamlessly merging advanced technological solutions with core business operations for the modern era.",
    icon: FileText
  }];
  const details = [{
    id: "item-1",
    title: "Market Intelligence & Research",
    content: "We provide granular analysis of global market shifts and consumer behavior, enabling your leadership to make informed decisions that secure a competitive advantage in volatile landscapes.",
    icon: Users
  }, {
    id: "item-2",
    title: "Corporate Governance & ESG",
    content: "Our advisors implement robust environmental, social, and governance frameworks that align with international standards, ensuring your organization leads with integrity and transparency.",
    icon: Handshake
  }, {
    id: "item-3",
    title: "Crisis Management & Resilience",
    content: "Developing comprehensive contingency protocols to protect your brand's reputation and operational continuity during unforeseen global or industrial disruptions.",
    icon: Gavel
  }, {
    id: "item-4",
    title: "Wealth & Legacy Structuring",
    content: "Specialized consulting for long-term capital preservation and intergenerational transition, utilizing sophisticated legal and financial vehicles for asset protection.",
    icon: Scroll
  }];
  return;
}